import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import {
    type CompetitionCollection,
    type CompetitionCollectionAvailability,
    type CompetitionCollectionStatus,
} from '@app/client/common/structs';

type CollectionStatuses = Record<string, CompetitionCollectionStatus>;

interface FantasyCollectionState {
    collections: CompetitionCollection[];
    collectionsStatuses: CollectionStatuses;
    collectionsValidity: CompetitionCollectionAvailability;
    setCollectionsStatuses: (updatedCollections: CompetitionCollection[]) => void;
    setCollectionsValidity: (updatedValidity: CompetitionCollectionAvailability) => void;
    clearCollections: () => void;
}

const initialState = {
    collections: [],
    collectionsStatuses: {},
    collectionsValidity: {},
};
export const useFantasyCollectionValidityStore = create<FantasyCollectionState>()(
    devtools(
        (set) => ({
            ...initialState,
            setCollectionsStatuses: (updatedCollections) =>
                set((state) => {
                    const statuses = { ...state.collectionsStatuses };
                    for (const col of updatedCollections) {
                        const { slug, status } = col;
                        statuses[slug] = status;
                    }
                    return { collections: updatedCollections, collectionsStatuses: statuses };
                }),
            setCollectionsValidity: (updatedValidity) =>
                set((state) => {
                    const validity = { ...state.collectionsValidity };
                    const criteriaItems = updatedValidity;
                    if (criteriaItems) {
                        for (const collection in criteriaItems) {
                            validity[collection] = criteriaItems[collection];
                        }
                    }

                    return { collectionsValidity: validity };
                }),

            clearCollections: () => set(initialState),
        }),
        { name: 'fantasy-collection-validity' },
    ),
);
